import topDownViewImg from '../assets/3d_view_angles/Top.webp';
import frontViewImg from '../assets/3d_view_angles/Front.webp';
import leftCornerViewImg from '../assets/3d_view_angles/L_Corner.webp';
import rightCornerViewImg from '../assets/3d_view_angles/R_Coner.webp';
import cutawayLeftCornerViewImg from '../assets/3d_view_angles/L_Corner_Cut.webp';
import cutawayRightCornerViewImg from '../assets/3d_view_angles/R_Corner_Cut.webp';
import cutawayFrontViewImg from '../assets/3d_view_angles/Front_Cut.webp';

export const FLOOR_PLAN_3D_CAMERA_VIEW_DEFAULT = 'left-corner-view';

/** Left-to-right popup grid order: left column, center, right column. */
export const FLOOR_PLAN_3D_CAMERA_VIEW_POPUP_ORDER = [
  'left-corner-view',
  'front-view',
  'right-corner-view',
  'cutaway-left-corner-view',
  'cutaway-front-view',
  'cutaway-right-corner-view',
  'top-down-view',
];

export const FLOOR_PLAN_3D_CAMERA_VIEW_OPTIONS = [
  {
    value: 'top-down-view',
    label: 'Top-Down View',
    image: topDownViewImg,
  },
  {
    value: 'front-view',
    label: 'Front View',
    image: frontViewImg,
  },
  {
    value: 'left-corner-view',
    label: 'Left Corner View',
    image: leftCornerViewImg,
  },
  {
    value: 'right-corner-view',
    label: 'Right Corner View',
    image: rightCornerViewImg,
  },
  {
    value: 'cutaway-left-corner-view',
    label: 'Cutaway - Left Corner View',
    image: cutawayLeftCornerViewImg,
  },
  {
    value: 'cutaway-right-corner-view',
    label: 'Cutaway - Right Corner View',
    image: cutawayRightCornerViewImg,
  },
  {
    value: 'cutaway-front-view',
    label: 'Cutaway - Front View',
    image: cutawayFrontViewImg,
  },
];

/** @type {Record<string, string>} */
const LEGACY_CAMERA_VIEW_MAP = {
  'top-view': 'top-down-view',
  'corner-view': 'left-corner-view',
  'front-view': 'front-view',
  'cutaway-view': 'cutaway-front-view',
  'front-left-angle': 'left-corner-view',
  'front-right-angle': 'right-corner-view',
  'left-to-right-angle': 'left-corner-view',
  'right-to-left-angle': 'right-corner-view',
  'center-view': 'front-view',
  'left-corner-view': 'left-corner-view',
  'right-corner-view': 'right-corner-view',
  'cutaway-preview': 'cutaway-front-view',
  'realistic-cutaway-preview': 'cutaway-front-view',
};

const CANONICAL_CAMERA_VIEWS = new Set(
  FLOOR_PLAN_3D_CAMERA_VIEW_OPTIONS.map((option) => option.value),
);

/** @type {Map<string, number>} */
const CAMERA_VIEW_POPUP_ORDER_INDEX = new Map(
  FLOOR_PLAN_3D_CAMERA_VIEW_POPUP_ORDER.map((value, index) => [value, index]),
);

/**
 * Camera view options sorted for the spatial popup grid (left | front | right).
 * @returns {typeof FLOOR_PLAN_3D_CAMERA_VIEW_OPTIONS}
 */
export function getFloorPlan3dCameraViewPopupOptions() {
  return [...FLOOR_PLAN_3D_CAMERA_VIEW_OPTIONS].sort(
    (a, b) =>
      (CAMERA_VIEW_POPUP_ORDER_INDEX.get(a.value) ?? Number.MAX_SAFE_INTEGER) -
      (CAMERA_VIEW_POPUP_ORDER_INDEX.get(b.value) ?? Number.MAX_SAFE_INTEGER),
  );
}

/**
 * Map stored or legacy camera view values to a canonical option value for the UI.
 * @param {string} [cameraView]
 * @returns {string}
 */
export function normalizeFloorPlan3dCameraViewForUi(cameraView) {
  const raw = typeof cameraView === 'string' ? cameraView.trim() : '';
  if (CANONICAL_CAMERA_VIEWS.has(raw)) {
    return raw;
  }
  if (raw in LEGACY_CAMERA_VIEW_MAP) {
    return LEGACY_CAMERA_VIEW_MAP[raw];
  }
  return FLOOR_PLAN_3D_CAMERA_VIEW_DEFAULT;
}
